<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Maklumat Menu"
  >
    <z-page 
      :title="menu.label" 
      :icon="menu.icon"
    >

      <w-card bg-color="z-pale-blue" class="mt4">
        <w-flex justify-center align-center>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Label :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.label }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Ikon :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.icon }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Route :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.route }} </div>
      </div>
    </w-flex>

    <w-flex class="mt3 mb4">
        <div class="xs4">
          <h5 class="fw-semibold m0">
              Tarikh Cipta :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.created_at) }} </div>
      </div>
        <div class="xs4">
            <h5 class="fw-semibold m0">
                Tarikh Ubah Akhir :
            </h5>
            <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.updated_at) }} </div>
        </div>
  
        </w-flex>

        <w-tabs
          :items="tabs"
          :no-slider="false"
          active-class="primary">
          
          <template #item-content.1>
            <MenuList
              :menu="menu"
              :items="items"
            />
          </template>

          <template #item-content.2>
            <permission
              title="Senarai Peranan"
              :user="menu"
              :items="roles"
              parent="administration.menu.update"
              which="role"
              v-model:selected="menu.roles_id"
              >
            </permission>                
          </template>

          <template #item-content.3>
            <permission
              title="Senarai Kebenaran"
              :user="menu"
              :items="permissions"
              parent="administration.menu.update"
              which="permission"
              v-model:selected="menu.permissions_id"
              >
            </permission>                
          </template>
        </w-tabs>

      </w-card>
        
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'

import ZResource from '@/Modules/z-resource'
import Permission from '../User/Subs/Permission.vue'
import MenuList from './Subs/Menu.vue'

export default {
  extends: ZResource,
  components: {
    MenuList,
    Permission
  },
  props: {
    menu: [Array, Object],
    items: [Array, Object],
    roles: [Array, Object],
    permissions: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.menu',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Menu', route: '/administration/menu' },
        { label: this.menu.label , route: '/admin/menu' }
      ],
      tabs: [
        { title: 'Sub Menu', content: '' },
        { title: 'Peranan', content: '' },
        { title: 'Kebenaran', content: '' },
      ],
    }
  },
  methods: {
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>